import React, { useEffect } from 'react';
// import './style/main.less';

import { useAppSelector, useAppDispatch } from './hooks';
import { login } from './auth/auth-slice';
import { useAuth0 } from '@auth0/auth0-react';
import { BrowserRouter as Router, Routes, Route, RouterProvider } from 'react-router-dom';
import { appRoutes } from './App-router';
import { getEffectivePermissions, NotFoundError } from './features/api/auth-api';
import NoAccess from './components/common/NoAccess';

if (process.env.REACT_APP_ENABLE_MOCK === 'true' && process.env.NODE_ENV !== 'test') {
    const { mockWorker } = require('./mocks/mockWorker');
    mockWorker.start();
}

function App() {
    const { loginWithRedirect, isAuthenticated, user, isLoading, getAccessTokenSilently } =
        useAuth0();

    const [hasFetchedEffectivePermissions, setHasFetchedEffectivePermissions] = React.useState(false);
    const [showNoAccess, setShowNoAccess] = React.useState(false);

    const hasAccess = useAppSelector((state) => state.auth.hasApplicationAccess);
    const dispatch = useAppDispatch();
    // console.log('isAuthenticated', isAuthenticated);

    useEffect(() => {
        if (user && isAuthenticated && !isLoading && !hasFetchedEffectivePermissions) {
            getAccessTokenSilently().then((token) => {
                getEffectivePermissions(token).then(response => {
                    const hasApplicationAccess = response.data.hasApplicationAccess;
                    dispatch(
                        login({
                            hasApplicationAccess: hasApplicationAccess,
                            token: token,
                            user: user,
                        })
                    );

                    if (!hasApplicationAccess) {
                        setShowNoAccess(true);
                    }
                    const decodedToken = JSON.parse(atob(token.split('.')[1])); // Decode JWT token
                    sessionStorage.setItem('userEmail', decodedToken['https://redwoodprofile.com/email'])
                })
                    .catch((error) => {
                        if (error instanceof NotFoundError) {
                            setShowNoAccess(true);
                        }
                    })
                    .finally(() => setHasFetchedEffectivePermissions(true));
            }).catch(() => setHasFetchedEffectivePermissions(true));
        }

    }, [user, isAuthenticated, isLoading, hasFetchedEffectivePermissions]);

    useEffect(() => {
        if (!isLoading && !isAuthenticated && !user) {
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, user]);

    useEffect(() => {
        if (!isLoading && !isAuthenticated && !user && !showNoAccess) {
            let pathToStore = window.location.pathname;
            const queries = window.location.search;
            if (queries !== undefined) {
                pathToStore += queries;
            }
            loginWithRedirect({ appState: { returnTo: pathToStore } });
        }
    }, [isLoading, isAuthenticated, user, showNoAccess]);

    if (showNoAccess) {
        return <NoAccess />;
    }

    if (isAuthenticated && !isLoading && hasFetchedEffectivePermissions && hasAccess) {
        return <RouterProvider router={appRoutes} />;
    }

    return <>Loading</>;

}

export default App;